require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[47],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 432:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(433);


/***/ }),

/***/ 433:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

exports.__esModule = true;

var _Radio = _interopRequireWildcard(__webpack_require__(434));

exports["default"] = _Radio["default"];
exports.Radio = _Radio["default"];
exports.renderCarbonRadioButton = _Radio.renderCarbonRadioButton;

/***/ }),

/***/ 434:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = exports.renderCarbonRadioButton = void 0;

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _baUiCarbon = __webpack_require__(12);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-common
 * (C) Copyright IBM Corp. 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var BaPropTypes = _utils.propsUtils.BaPropTypes;

var renderCarbonRadioButton = function renderCarbonRadioButton(props) {
  var labelPosition = props.labelPosition,
      labelText = props.labelText,
      active = props.active,
      align = props.align,
      hover = props.hover,
      label = props.label,
      readOnly = props.readOnly,
      tabIndex = props.tabIndex,
      title = props.title,
      otherRadioButtonProps = (0, _objectWithoutPropertiesLoose2["default"])(props, ["labelPosition", "labelText", "active", "align", "hover", "label", "readOnly", "tabIndex", "title"]);
  var mappedLabelPosition = labelPosition != null ? labelPosition : align === 'right' ? 'left' : undefined;
  var mappedLabelText = labelText != null ? labelText : label;
  return /*#__PURE__*/_react["default"].createElement(_baUiCarbon.RadioButton, (0, _extends2["default"])({}, otherRadioButtonProps, {
    labelPosition: mappedLabelPosition,
    labelText: mappedLabelText
  }));
};

exports.renderCarbonRadioButton = renderCarbonRadioButton;

var Radio = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(Radio, _Component);

  function Radio() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Radio.prototype;

  _proto.render = function render() {
    return renderCarbonRadioButton(this.props);
  };

  return Radio;
}(_react.Component);

exports["default"] = Radio;
(0, _defineProperty2["default"])(Radio, "propTypes", (0, _extends2["default"])({}, _baUiCarbon.RadioButton.propTypes, {
  /** deprecated - no Carbon option */
  active: BaPropTypes.deprecated('deprecated - no Carbon option'),

  /** deprecated - use labelPosition */
  align: BaPropTypes.deprecated('deprecated - use labelPosition'),

  /** deprecated - no Carbon option */
  hover: BaPropTypes.deprecated('deprecated - no Carbon option'),

  /** deprecated - use labelText  */
  label: BaPropTypes.deprecated('deprecated - use labelText'),

  /** deprecated - no Carbon option(maybe disabled) */
  readOnly: BaPropTypes.deprecated('deprecated - no Carbon option(maybe disabled)'),

  /** deprecated - no Carbon option */
  tabIndex: BaPropTypes.deprecated('deprecated - no Carbon option'),

  /** deprecated - no Carbon option */
  title: BaPropTypes.deprecated('deprecated - no Carbon option')
}));

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ })

},[[432,0]]]);
});